/**
 * @file Story Modal
 */

import gsap from 'gsap';

/**
 * Story Modal component
 */
const vStoryModal = () => {
	const storyModal = document.querySelectorAll( '.v-story-modal' );

	if ( ! storyModal ) {
		return;
	}

	[ ...storyModal ].forEach( ( el ) => {
		const closeBtn  = el.querySelector( '.v-story-modal__close-btn' );
		const storyWrap = el.querySelector( '.v-story-modal__story-wrap' );
		const gradient  = el.querySelector( '.v-story-modal__border' );

		/**
		 * Close this modal
		 */
		const closeModal = () => {
			gsap.timeline( {
				defaults:   { ease: 'power1.inOut', duration: .6 },
				onComplete: () => {
					el.classList.add( 'v-story-modal--hidden' );
					el.dataset.visible = 'false';

					// Reset gsap
					storyWrap.removeAttribute( 'style' );
					gradient.removeAttribute( 'style' );
					el.removeAttribute( 'style' );
				},
			} )
				.to( storyWrap, {
					opacity: 0,
				} )
				.to( gradient, {
					scale:   .7,
					opacity: 0,
				} )
				.to( el, {
					opacity: 0,
				}, '<15%' );
		};

		closeBtn.addEventListener( 'click', ( e ) => {
			e.preventDefault();
			closeModal();
		} );

		el.addEventListener( 'click', ( e ) => {
			const { target } = e;

			if ( storyWrap.contains( target ) ) {
				return;
			}

			closeModal();
		} );
	} );
};

export default vStoryModal;
